/**
 * The public site's fixed disclaimers — the sentences that have to say "advice", "valuation" or
 * "guarantee" in order to deny them (WEBSITE_SPEC §6 "Compliance furniture"; Legal.dc.html).
 *
 * Same discipline as `provenance.ts` and `deal-discovery.ts`: a negated banned word is a disclaimer,
 * not a claim, and the exception is the exact sentence rather than the word — a page may print
 * these and nothing else may use the words. `web.test.ts` parses WEBSITE_SPEC §6 and fails if a
 * character drifts. Wording is a plain-English draft that goes to counsel (Legal page, every region).
 */

/** The advice heading and sentence per market (the Legal page, `LEGAL_BY_REGION`). */
export const ADVICE_HEADING = {
  au: "Not financial product advice",
  uk: "Not financial advice",
  ca: "Not financial advice",
} as const;

export const ADVICE_BODY = {
  au: "That is an operational opinion, not financial product advice, and we are not licensed to give financial product advice.",
  uk: "That is an operational opinion, not financial advice or a personal recommendation, and we are not authorised to give financial advice.",
  ca: "That is an operational opinion, not financial, legal or tax advice, and we are not registered to give financial advice.",
} as const;

/** The footer's advice line per market. */
export const ADVICE_LINE = {
  au: "nothing on this site is financial product advice",
  uk: "nothing on this site is financial, legal or tax advice",
  ca: "nothing on this site is financial, legal or tax advice",
} as const;

/** Terms: what a review is not. */
export const WHAT_A_REVIEW_IS_NOT =
  "It is not a valuation, an audit in the accounting sense, a due-diligence report, or a guarantee of any result. "
  + "The scenarios are estimates, clearly labelled as such.";

/** The landing page's "what it is not" block for the daily note. */
export const NOTE_WHAT_IT_IS_NOT =
  "Not a mandate, not an offer, and not advice. We have no engagement with any party to any of these sales, and we "
  + "are paid nothing if one completes.";

/** The footer sentence about the two things we are not. */
export const NOT_YOUR_AGENT_FOOTER = "We are not your agent and we do not negotiate on your behalf.";

export const WEB_STRINGS: readonly string[] = [
  ...Object.values(ADVICE_HEADING), ...Object.values(ADVICE_BODY), ...Object.values(ADVICE_LINE),
  WHAT_A_REVIEW_IS_NOT, NOTE_WHAT_IT_IS_NOT, NOT_YOUR_AGENT_FOOTER,
];
